<section class="form-enterprises py-4">
    <div class="container p-0">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="row g-3">
                <!-- Nombre -->
                <div class="col-md-6">
                    <label for="nombre" class="form-label">
                        {{ 'fe_enterprises_form_label_1' | translate }}
                    </label>
                    <input
                        id="nombre"
                        formControlName="nombre"
                        class="form-control"
                        placeholder="{{
                            'fe_enterprises_form_placeholder_1' | translate
                        }}"
                    />
                </div>

                <!-- WhatsApp -->
                <div class="col-md-6">
                    <label for="telefono" class="form-label">
                        {{ 'fe_enterprises_form_label_2' | translate }}
                    </label>
                    <div class="input-group">
                        <!-- Select País -->
                        <select
                            id="pais"
                            formControlName="pais"
                            class="form-select"
                            style="max-width: 160px"
                        >
                            <option *ngFor="let p of paises" [value]="p.codigo">
                                {{ p.nombre }} ({{ p.lada }})
                            </option>
                        </select>

                        <!-- Lada -->
                        <span class="input-group-text lada-input">
                            {{ selectedLada }}
                        </span>

                        <!-- Número -->
                        <input
                            id="telefono"
                            formControlName="telefono"
                            class="form-control wa-input"
                            placeholder="{{
                                'fe_enterprises_form_placeholder_2' | translate
                            }}"
                            maxlength="15"
                        />
                    </div>
                </div>

                <!-- Correo -->
                <div class="col-md-12">
                    <label for="correo" class="form-label">
                        {{ 'fe_enterprises_form_label_3' | translate }}
                    </label>
                    <input
                        id="correo"
                        formControlName="correo"
                        class="form-control"
                        placeholder="{{
                            'fe_enterprises_form_placeholder_3' | translate
                        }}"
                    />
                </div>

                <!-- Teléfono Oficina -->
                <div class="col-md-6">
                    <label for="telefonoOficina" class="form-label">
                        {{ 'fe_enterprises_form_label_4' | translate }}
                    </label>
                    <input
                        id="telefonoOficina"
                        formControlName="telefonoOficina"
                        class="form-control"
                        placeholder="{{
                            'fe_enterprises_form_placeholder_4' | translate
                        }}"
                    />
                </div>

                <!-- Estado -->
                <div class="col-md-6 position-relative">
                    <label for="estado" class="form-label">
                        {{ 'fe_enterprises_form_label_5' | translate }}
                    </label>
                    <select
                        id="estado"
                        formControlName="estado"
                        class="form-select"
                        [disabled]="loadingEstados"
                    >
                        <option value="">
                            {{
                                loadingEstados
                                    ? 'Cargando estados...'
                                    : ('Selecciona' | translate)
                            }}
                        </option>
                        <option *ngFor="let est of estados" [value]="est">
                            {{ est }}
                        </option>
                    </select>

                    <div
                        *ngIf="loadingEstados"
                        class="spinner-border text-primary spinner-border-sm position-absolute top-50 end-0 me-3 translate-middle-y"
                        role="status"
                    ></div>
                </div>

                <!-- Municipio -->
                <div class="col-md-6 position-relative">
                    <label for="municipio" class="form-label">
                        {{ 'fe_enterprises_form_label_6' | translate }}
                    </label>
                    <select
                        id="municipio"
                        formControlName="municipio"
                        class="form-select"
                        [disabled]="loadingMunicipios || !municipios.length"
                    >
                        <option value="">
                            {{
                                loadingMunicipios
                                    ? 'Cargando municipios...'
                                    : ('Selecciona' | translate)
                            }}
                        </option>
                        <option *ngFor="let mun of municipios" [value]="mun">
                            {{ mun }}
                        </option>
                    </select>

                    <div
                        *ngIf="loadingMunicipios"
                        class="spinner-border text-success spinner-border-sm position-absolute top-50 end-0 me-3 translate-middle-y"
                        role="status"
                    ></div>
                </div>

                <!-- Empresa -->
                <div class="col-md-6">
                    <label for="empresa" class="form-label">
                        {{ 'fe_enterprises_form_label_7' | translate }}
                    </label>
                    <input
                        id="empresa"
                        formControlName="empresa"
                        class="form-control"
                        placeholder="{{
                            'fe_enterprises_form_placeholder_7' | translate
                        }}"
                    />
                </div>

                <!-- Giro -->
                <div class="col-md-6">
                    <label for="giro" class="form-label">
                        {{ 'fe_enterprises_form_label_8' | translate }}
                    </label>
                    <select
                        id="giro"
                        formControlName="giro"
                        class="form-select"
                    >
                        <option disabled value="">Selecciona</option>
                        <option value="Agricultura">Agricultura</option>
                        <option value="Bienes raíces">Bienes raíces</option>
                        <option value="Cinematografía">Cinematografía</option>
                        <option value="Comercio al por mayor">
                            Comercio al por mayor
                        </option>
                        <option value="Comercio al por menor">
                            Comercio al por menor
                        </option>
                        <option value="Construcción">Construcción</option>
                        <option value="Editorial">Editorial</option>
                        <option value="Educación">Educación</option>
                        <option value="Electricidad">Electricidad</option>
                        <option value="Energía">Energía</option>
                        <option value="Ganadería">Ganadería</option>
                        <option value="Gobierno">Gobierno</option>
                        <option value="Manufactura">Manufactura</option>
                        <option value="Metalurgia">Metalurgia</option>
                        <option value="Minería">Minería</option>
                        <option value="Pesca">Pesca</option>
                        <option value="Publicidad">Publicidad</option>
                        <option value="Salud">Salud</option>
                        <option value="Seguridad">Seguridad</option>
                        <option value="Servicios financieros">
                            Servicios financieros
                        </option>
                        <option value="Software">Software</option>
                        <option value="Telecomunicaciones">
                            Telecomunicaciones
                        </option>
                        <option value="Transportes, correo y almacenamiento">
                            Transportes, correo y almacenamiento
                        </option>
                        <option value="Turismo">Turismo</option>
                        <option value="Otros">Otros</option>
                    </select>
                </div>

                <!-- Puesto -->
                <div class="col-md-6">
                    <label for="puesto" class="form-label">
                        {{ 'fe_enterprises_form_label_9' | translate }}
                    </label>
                    <select
                        id="puesto"
                        formControlName="puesto"
                        class="form-select"
                    >
                        <option disabled value="">Selecciona</option>
                        <option value="Gerente">Gerente</option>
                        <option value="Asistente de dirección">
                            Asistente de dirección
                        </option>
                        <option value="Compras">Compras</option>
                        <option value="Comercial/Ventas">
                            Comercial/Ventas
                        </option>
                        <option value="Administración">Administración</option>
                        <option value="Operaciones">Operaciones</option>
                        <option value="Recursos Humanos">
                            Recursos Humanos
                        </option>
                        <option value="Tour &amp; Travel">
                            Tour &amp; Travel
                        </option>
                        <option value="Marketing">Marketing</option>
                        <option value="Otro">Otro</option>
                    </select>
                </div>
                <input
                    type="hidden"
                    formControlName="landing_page"
                    name="landing_page"
                    id="landing_page"
                />

                <!-- Captcha -->
                <div class="col-12 my-3">
                    <div
                        class="g-recaptcha d-inline-block"
                        data-sitekey="6Lch8xEsAAAAAP6-caMRN41zqfbN7skuwo1HY9U-"
                    ></div>
                </div>

                <!-- Botón -->
                <div class="col-12 m-0">
                    <button
                        class="btn btn-warning btn-lg px-5"
                        type="submit"
                        [disabled]="form.invalid"
                    >
                        {{ 'fe_enterprises_form_cta' | translate }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</section>
